export default __webpack_public_path__ + "static/media/bebeco.785549de.jpg";